import { HighlightVariant } from './highlight-layer/HighlightLayer.props';
import { PageData, PDFCitationPayload, Rect } from './pdf-utils/constants';
import { CitationReferenceData } from '../../../services/reference-generator/types';

export enum PDFViewerViewMode {
  DOCUMENT = 'DOCUMENT',
  THUMBNAIL = 'THUMBNAIL',
}

export type PDFViewerPageChrome = 'floating' | 'header';

export interface SearchHighlight {
  pageNumber: number;
  wordIds: number[];
  rects: Rect[];
}

export interface PDFViewerProps {
  src?: string;
  base64Content?: string;
  isSourceLoading?: boolean;
  allowNativeTextSelection?: boolean;
  allowPageSelection?: boolean;
  deferResizeUpdates?: boolean;
  pageChrome?: PDFViewerPageChrome;
  selectedPages?: Set<number>;
  onPageToggle?: (pageNumber: number) => void;
  viewMode: PDFViewerViewMode;
  zoomScale?: number;
  onZoomScaleChange?: (zoomScale: number) => void;
  jsonData?: PageData[];
  activeCitation?: CitationReferenceData;
  /** Highlight color for the active citation; 'ai' for review-mode jumps. Defaults to 'citation'. */
  activeCitationVariant?: HighlightVariant;
  /**
   * Bumped by the citation context on every activation, so re-activating the citation
   * that is ALREADY active still re-triggers the scroll-to-citation effect.
   */
  activeCitationNonce?: number;
  onCitationPushed?: (payload: PDFCitationPayload) => void;
  searchHighlight?: SearchHighlight | null;
  searchOpen?: boolean;
  onSearchToggle?: () => void;
}
